import { ContentInput, useUpsertContentMutation } from '@converge/graphql';
import { useConvergeSnackBar } from '../../contexts';
import { FormProvider, useForm } from 'react-hook-form';
import { FormTextField } from '../../presentation';
import { Stack } from '@mui/system';
import { useEffect } from 'react';

interface IContentCreateFormProps extends Partial<ContentInput> {
  labelMargin?: number;
  minHeight?: number;
  minHeightForTextFile?: number;
}

export const ContentCreateForm = ({
  targetArea,
  label,
  targetUuid,
  targetSubUuid,
  labelMargin,
  minHeight,
  content,
  minHeightForTextFile,
  ...props
}: IContentCreateFormProps) => {
  const { notify } = useConvergeSnackBar();

  const { upsertContent } = useUpsertContentMutation({
    onError: (error) =>
      notify(`Failed to add note: ${error.message}`, {
        variant: 'error',
      }),
  });

  const formMethods = useForm<ContentInput>({
    mode: 'all',
  });

  useEffect(() => {
    formMethods.reset({
      content: content,
      targetArea,
      targetUuid: targetUuid,
      label,
      targetSubUuid,
    });
    formMethods.setValue('content', content || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  const contentHandler = async () => {
    const selectedContent = formMethods.watch('content');

    try {
      await upsertContent({
        variables: {
          details: {
            targetArea,
            targetUuid,
            label,
            content: selectedContent,
          } as ContentInput,
        },
      });
      notify({
        message: 'Content added',
        variant: 'success',
      });
    } catch (error) {
      notify(`Failed to add content`, {
        variant: 'error',
      });
    }
  };
  return (
    <FormProvider {...formMethods}>
      <Stack marginBottom={2}>
        <FormTextField
          isRichText
          hiddenLabel
          name="content"
          label="content"
          // defaultValue={content}
          value={content}
          multiline
          rows={4}
          containerWidth={12}
          labelMargin={30}
          minHeight={500}
          minHeightForTextFile={350}
          onBlur={contentHandler}
        />
      </Stack>
    </FormProvider>
  );
};
